import { Colors, FlexBox, Text } from '@helloself/hello-self-ui';
import React from 'react';
import Skeleton from 'react-loading-skeleton';

export type InsurerIconsProps = {
    isLoading: boolean;
    errorMessage?: string;
    icons?: JSX.Element[];
};

export function InsurerIcons({ isLoading, errorMessage, icons }: InsurerIconsProps) {
    if (isLoading) {
        return <Skeleton width="270px" height="40px" borderRadius="6px" />;
    }

    if (errorMessage) {
        return (
            <FlexBox gap={'24px'}>
                <Text textColor={Colors.pink}>{errorMessage}</Text>
            </FlexBox>
        );
    }

    return (
        <FlexBox gap={'24px'} flexWrap={'wrap'}>
            {icons}
        </FlexBox>
    );
}
